var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfilReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9749 1.66669C11.4166 1.66669 11.8416 1.84169 12.1582 2.15835L16.1749 6.18336C16.4916 6.49169 16.6666 6.91669 16.6666 7.35836V16.6667C16.6666 17.5834 15.9166 18.3334 14.9999 18.3334H4.99158C4.07492 18.3334 3.33325 17.5834 3.33325 16.6667V3.33335C3.33325 2.41669 4.08325 1.66669 4.99992 1.66669H10.9749ZM10.8333 2.91669V6.66669C10.8333 7.12502 11.2082 7.50002 11.6666 7.50002H15.4166L10.8333 2.91669ZM12.5925 10.7408C12.5925 12.1726 11.4318 13.3334 9.99992 13.3334C8.56807 13.3334 7.40733 12.1726 7.40733 10.7408C7.40733 9.30891 8.56807 8.14817 9.99992 8.14817C11.4318 8.14817 12.5925 9.30891 12.5925 10.7408ZM4.81473 17.0371V16.8667C4.81473 16.4074 5.02216 15.9778 5.3777 15.6963C6.64434 14.6815 8.25178 14.0741 9.99992 14.0741C11.7481 14.0741 13.3555 14.6815 14.6221 15.6963C14.9777 15.9778 15.1851 16.4148 15.1851 16.8667V17.0371H4.81473Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfilReport);
export default __webpack_public_path__ + "static/media/perfilReport.60a165f8be002f777f3db8d22b24bc1d.svg";
export { ForwardRef as ReactComponent };